import FeatureFlagService, { flags } from '@src/terminal/core/services/flags/FeatureFlagService';
import StoreUtil from '@store/StoreUtil';
import { Dispatch } from 'vuex';

export interface IFlagModuleState {
  isInPlayAvailable: boolean;
  isBetlerEnabled: boolean;
}

function defaultState(): IFlagModuleState {
  return {
    // ssbt.product.in-play
    isInPlayAvailable: flags.inPlay.defaultValue,
    // retail.betler-wallet
    isBetlerEnabled: flags.betlerWallet.defaultValue,
  };
}

export const Mutations = {
  SET_IS_IN_PLAY_AVAILABLE: 'SET_IS_IN_PLAY_AVAILABLE',
  SET_IS_BETLER_ENABLED: 'SET_IS_BETLER_ENABLED',
};

const mutations = {
  [Mutations.SET_IS_IN_PLAY_AVAILABLE]: StoreUtil.createSimpleMutator('isInPlayAvailable'),
  [Mutations.SET_IS_BETLER_ENABLED]: StoreUtil.createSimpleMutator('isBetlerEnabled'),
};

const actions = {
  setIsInPlayAvailable: StoreUtil.createSimpleMutatorAction(Mutations.SET_IS_IN_PLAY_AVAILABLE),
  setIsBetlerEnabled: StoreUtil.createSimpleMutatorAction(Mutations.SET_IS_BETLER_ENABLED),
  initFlags: ({ dispatch }: { dispatch: Dispatch }): void => {
    dispatch('setIsInPlayAvailable', FeatureFlagService.getInstance().isInPlayAvailable());
    dispatch('setIsBetlerEnabled', FeatureFlagService.getInstance().isBetlerEnabled());

    // subscriptions
    FeatureFlagService.getInstance().subscribeToFlagChange(flags.inPlay.name, (value) => {
      dispatch('setIsInPlayAvailable', value);
    });
    FeatureFlagService.getInstance().subscribeToFlagChange(flags.betlerWallet.name, (value) => {
      dispatch('setIsBetlerEnabled', value);
    });
  },
};

const getters = {
  isInPlayAvailable: StoreUtil.createSimpleGetter('isInPlayAvailable', flags.inPlay.defaultValue),
  isBetlerEnabled: StoreUtil.createSimpleGetter('isBetlerEnabled', flags.betlerWallet.defaultValue),
};

export default {
  namespaced: true,
  state: defaultState(),
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/store/flags/index.ts